<template lang="pug">
  div(data-testid="content-favorite")
    section.content-header
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 お気に入り

    section.content
      .bcard-btnbar.clearfix
        func-export(:checked-ids="checkedIds", :use-search="isAllPagesChecked", :conds="conditions")
        |
        |
        func-tag(:checked-ids="checkedIds", :use-search="isAllPagesChecked", :conds="conditions")
        |
        |
        func-edit(:checked-ids="checkedIds")
        |
        |
        func-favorite(:checked-ids="checkedIds")

      .panel.panel-default
        .panel-heading
          .row
            .col-xs-6
              //- 検索
              form(action="#", @submit.prevent="getList({page: {page: 1}})")
                .input-group.pull-left
                  input.form-control(type="text" name="free_word" v-model="freeWord" placeholder="氏名、会社名で検索")
                  span.input-group-btn
                    button.btn.btn-info(type="submit" title="検索", data-testid="-btn-card-search")
                      i.fa.fa-search
              func-advanced-search(v-model="conditions", :init="initParams.conds", @search="getList")
            .col-xs-6.text-right
              //- 一覧切り替えボタン
              portal-target(name="list_mode", tag="span")
              | &nbsp;&nbsp;
              app-sortmenu(:hidden="list.length === 0", :options="sortOptions", :current="sort" @change="sortList")

        loading(v-if="isLoading")
        card-list(
          v-else-if="list.length > 0",
          v-model="list",
          :pCheckedIds="checkedIds",
          :sort="sort",
          :use-favorite="true",
          @checkAll="checkAll",
          @checkItem="checkItem"
        )
        .panel-body.text-center(v-else) お気に入りはありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppSortmenu from '@/components/molecules/AppSortmenu'
import Loading from '@/components/molecules/Loading'
import FuncExport from '@/components/organisms/functions/FuncExport'
import FuncTag from '@/components/organisms/functions/FuncTag'
import FuncEdit from '@/components/organisms/functions/FuncEditCard'
import FuncFavorite from '@/components/organisms/functions/FuncFavorite'
import FuncAdvancedSearch from '@/components/organisms/functions/FuncAdvancedSearch'
import CardList from '@/components/organisms/lists/CardList'

export default {
  name: 'Favorite',
  components: {
    AppMessages,
    AppPagination,
    AppSortmenu,
    Loading,
    FuncExport,
    FuncTag,
    FuncEdit,
    FuncFavorite,
    FuncAdvancedSearch,
    CardList
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      sortOptions: [
        {'label': '氏名', 'sort_item': 'name'},
        {'label': '会社名', 'sort_item': 'corporate_name'},
        {'label': '部署名', 'sort_item': 'dept'},
        {'label': '役職', 'sort_item': 'post'},
        {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      ],

      // 検索条件（別にしておかないと、詳細検索のリセットで消えてしまう）
      freeWord: '',

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 },
        // ソート条件
        sort: { sort_item: 'name', direction: 'asc' },
        // 検索条件
        conds: {
          search_target: 'fav', // APIでは使わないけどfunctionsで使うので設定しておく
          openflag: ['0', '1'], // default: 両選択
          display_mode: '0' // 最新固定
        }
      }
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getList()
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      this.sort = Object.assign({}, this.initParams.sort)
      this.conditions = Object.assign({}, this.initParams.conds)
    }
    else {
      this.freeWord = this.conditions.free_word
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this
      options = options || {}

      let page = options.page || this.pagination.current_page || 1
      let sort = options.sort || this.sort || {}
      let conds = options.conds || this.conditions || {}
      conds.free_word = this.freeWord
      conds.search_target = this.initParams.conds.search_target

      // IDだけ抜き出し
      const in_introducer_ids = conds.in_introducer ? conds.in_introducer.map(user => user.id) : []
      const out_introducer_ids = conds.out_introducer ? conds.out_introducer.map(person => person.id) : []
      const tags_ids = conds.tags ? conds.tags.map(tag => tag.id) : []

      let params = {
        // page
        page,
        // sort
        sort_item: sort.sort_item,
        direction: sort.direction,
        // conditions
        search_target: conds.search_target,
        free_word: conds.free_word,
        name: conds.name || '',
        corporate_name: conds.corporate_name || '',
        dept_post: conds.dept_post || '',
        zipcode: conds.zipcode || '',
        address: conds.address || '',
        tel: conds.tel || '',
        fax: conds.fax || '',
        mail: conds.mail || '',
        memo: conds.memo || '',
        keywords: conds.keywords || '',
        openflag: conds.openflag || '',
        tags: tags_ids,
        exchange_date_from: conds.exchange_date_from || '',
        exchange_date_to: conds.exchange_date_to || '',
        ex_location: conds.ex_location || '',
        ex_trigger: conds.ex_trigger || '',
        in_introducer: in_introducer_ids,
        out_introducer: out_introducer_ids,
        age: conds.age || '',
        display_mode: conds.display_mode
      }

      this.clearErrorMessages()
      this.isLoading = true

      // 一覧取得
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'bcard',
        method: 'searchFav',
        params,
        onSuccess (response) {
          // sendListRequestでやってるsetListCondsをやり直し
          vm.conditions = Object.assign({}, conds, sort) // condsにもsortがあるのでsortが後
          vm.setListConds()
        },
        finally () {
          vm.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/FilterFavorited.vue